/** Colunas do order by da pesquisa dos pedidos */
export enum PedidoSearchOrderBy {
    Numero = 1,
    NumeroErp = 2,
    NumeroENumeroErp = 3,
    DataEmissao = 4,
    DataEmissaoENumeroENumeroErp = 5,
    ValorTotal = 6,
    TipoVenda = 7,
    Status = 8,
    SetorGep = 9,
    NomeCliente = 10,
    NomeRepresentante = 11,
    NomeTabelaPreco = 12,
    NomeCampanha = 13,
    MotivoReprovado = 14,
    NomeCondicaoPagamento = 15,
    QuantidadeTotal = 16,
    NumeroEcommerce = 17,
    MotivoNaoLiberado = 18,
    DataNaoLiberado = 19,
    ValorRegraNaoLiberado = 20,
    ValorLucroLiquidoNaoLiberado = 21,
    DataLiberado = 22,
    UsuarioLiberado = 23,
    JustificativaLiberado = 24,
    PercLucroLiquido = 25,
    DataConfirmacao = 26,
    DataConfirmacaoENumeroENumeroErp = 27,
    QuantidadeVolumesPrevistos = 28,
    QuantidadeVolumesEfetivos = 29,
    ClassificacaoFaturamentoPretendida = 30
};
